export const effectivePricingPlan = shop => shop && Object.prototype.hasOwnProperty.call(shop, 'effectivePricingPlan')
  ? shop.effectivePricingPlan : shop?.pricingPlan
